module.exports = __webpack_public_path__ + "img/pikachu.eb2bba33.jpg";